import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import BackButton from '../BackButton/BackButton'
import StarRating from '../StarRating/StarRating'
import Api from '../../services/api'

const fullName = (assessor) => {
  return [assessor.firstName, assessor.lastName].filter(Boolean).join(' ') ||
    assessor.tradingName ||
    'Assessor'
}

const locationText = (location) => {
  if (!location) return ''
  if (typeof location === 'string') return location
  return [location.town, location.state, location.postcode].filter(Boolean).join(', ')
}

const listingText = (lot) => {
  return (lot.publicDetails && lot.publicDetails.title) || lot.searchNumericId || 'Listing'
}

class AssessorProfile extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      assessor: null,
      loaded: false
    }
  }

  componentDidMount () {
    window.scroll(0, 0)
    this.getAssessor()
  }

  async getAssessor () {
    const res = await Api.getAssessor(this.props.match.params.assessorId)
    this.setState({
      assessor: (res && res.assessor) ? res.assessor : null,
      loaded: true
    })
  }

  render () {
    if (!this.state.loaded) {
      return <div />
    }

    const assessor = this.state.assessor

    if (!assessor) {
      return (
        <div className='app-route'>
          <div className='body-container'>
            <div className='inner-container'>
              <div className='assessor-profile'>
                <div className='top-btns'>
                  <BackButton onPress={() => this.props.history.goBack()} name='Back' />
                </div>
                <p className='fg-paragraph'>Assessor not found.</p>
              </div>
            </div>
          </div>
        </div>
      )
    }

    const rating = assessor.rating || { average: 0, count: 0, breakdown: [] }
    const name = fullName(assessor)

    return (
      <div className='app-route'>
        <div className='body-container'>
          <div className='inner-container'>
            <div className='assessor-profile'>
              <div className='top-btns'>
                <BackButton onPress={() => this.props.history.goBack()} name='Back' />
              </div>

              <div className='assessor-header'>{name}</div>

              {assessor.bio && <div className='assessor-bio'>{assessor.bio}</div>}

              <div className='assessor-info-grid'>
                <div className='assessor-info-col'>
                  <p><span className='label'>Name:</span> {name}</p>
                  {assessor.tradingName &&
                    <p><span className='label'>Trading Name:</span> {assessor.tradingName}</p>}
                  {assessor.phone &&
                    <p><span className='label'>Phone:</span> {assessor.phone}</p>}
                  {assessor.email &&
                    <p><span className='label'>Email:</span> <a href={`mailto:${assessor.email}`}>{assessor.email}</a></p>}
                  {locationText(assessor.location) &&
                    <p><span className='label'>Location:</span> {locationText(assessor.location)}</p>}
                </div>
                <div className='assessor-info-col'>
                  {assessor.joinedAt &&
                    <p><span className='label'>Joined FarmGate:</span> {moment(assessor.joinedAt).format('YYYY')}</p>}
                  <p><span className='label'>Assessments Completed:</span> {assessor.assessmentsCompleted || 0}</p>
                </div>
              </div>

              <div className='assessor-rating-block'>
                <div className='assessor-rating-summary'>
                  <StarRating value={rating.average} showLabel={false} />
                  <span className='rating-value'>{Number(rating.average).toFixed(2)} ({rating.count} Reviews)</span>
                </div>
                {rating.breakdown && rating.breakdown.length > 0 &&
                  <div className='assessor-breakdown'>
                    {rating.breakdown.map((item, index) => (
                      <div className='breakdown-row' key={index}>
                        <span className='breakdown-label'>{item.title}:</span>
                        <StarRating value={item.average} size='sm' label={Number(item.average).toFixed(1)} />
                      </div>
                    ))}
                  </div>}
              </div>

              <div className='assessor-listings-grid'>
                <div className='assessor-listings-col'>
                  <h3>Upcoming Listings</h3>
                  {(assessor.upcomingListings || []).length === 0 && <p>No upcoming listings.</p>}
                  {(assessor.upcomingListings || []).map((lot, index) => (
                    <p className='listing-link' key={index}>{listingText(lot)}</p>
                  ))}
                </div>
                <div className='assessor-listings-col'>
                  <h3>Past Listings</h3>
                  {(assessor.pastListings || []).length === 0 && <p>No past listings.</p>}
                  {(assessor.pastListings || []).map((lot, index) => (
                    <p className='listing-link' key={index}>{listingText(lot)}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

AssessorProfile.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

export default AssessorProfile
